module.exports = __webpack_public_path__ + "static/media/cahrt-2.f098c074.png";